export default{
    perPage: 10,
    applicationId: 29,
    durationNewProfileItemInDays: 10,
    allOffers: ['35','43','45','58']
}
